import { GetAccess } from '../apis/PaymentModule.api';

export const ACCESS_QUERY_KEY = ['get-access'];

export const useAccess = () => {
  const { data: access, isLoading, error } = GetAccess();

  return {
    access,
    accessLoading: isLoading,
    accessError: error,
    hasAccess: (feature) => access?.[feature] === true,
  };
};
